import * as React from "react";
import styled, {css} from "../../../styled/index";
import darken from "polished/lib/color/darken";
import ReactTooltip from "react-tooltip";

export interface SideNavLinkProps {
  id: string;
  tip: string;
  icon: React.ReactNode;
  active: boolean;
  onClick: () => void;
}

const SideNavLinkComponent = styled("a")<{ active: boolean; }>`

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 42px;
  border-radius: 3px;
  
  font-size: 18px;
  background: ${({ active, theme }) => active ? theme.colors.primary : darken(0.1, theme.side_nav.background_color)};
  color: ${({ active, theme }) => active ? theme.colors.primary_text : theme.side_nav.text_color};
  
  &:hover {
    background-color: ${({theme}) => theme.colors.primary};
    color: ${({theme}) => theme.colors.primary_text};
  }
  
`;

export const SideNavLink = (props: SideNavLinkProps) => (
  <SideNavLinkComponent
    id={props.id}
    data-tip={props.tip}
    active={props.active}
    onClick={props.onClick}>
    {props.icon}
    <ReactTooltip place="right" effect="solid" multiline={false}/>
  </SideNavLinkComponent>
);
